// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7395) return "css/design_system-49b9f2a79bfe6b95f1e0.css";
	if (chunkId === 4955) return "css/4955-26df6bfbbb1076dde711.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2300":"5e2fdb02a6b02d8e71e7","2508":"fcf709e1890ff4fc4a91","5755":"05fbf81bdcc46309d62e"}[chunkId] + ".css";
};